/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import LanguageSelection from "@/shared/components/language/LanguageSelectionMenu";

import Logo from "../../../../components/Logo/Logo";
import { useEnableTwoFactorAuthentication } from "../../hooks";
import { ENABLE_AUTHENTICATION_STEPS } from "../../types";
import { MainIcon } from "./components/MainIcon";
import { Title } from "./components/Title";
import {
  GetEmailCode,
  SelectAuthenticationType,
  SendEmailCode,
  SendOtpCode,
  SuccessMessage
} from "./content";
import { useStyles } from "./styles";

const TwoFactorRequirement = () => {
  const {
    authType,
    error,
    isLoading,
    otpCode,
    secretKey,
    step,
    changeAuthenticationType,
    changeOtpCode,
    changeStep,
    getEmailCodeSubmit,
    getSecretKeySubmit,
    handleClose,
    sendOtpCodeSubmit,
    setError,
    setOtpCode,
    validateOtp
  } = useEnableTwoFactorAuthentication();

  const { twoFaPage, logoBlock, twoFaPageContainer, titleArea } = useStyles({
    step
  });

  const renderMainContent = () => {
    switch (step) {
      case ENABLE_AUTHENTICATION_STEPS.GetEmailCode:
        return (
          <GetEmailCode
            isLoading={isLoading}
            changeStep={changeStep}
            getEmailCodeSubmit={getEmailCodeSubmit}
          />
        );
      case ENABLE_AUTHENTICATION_STEPS.SendOtpCode:
        return (
          <SendOtpCode
            secretKey={secretKey}
            isLoading={isLoading}
            error={error}
            otpCode={otpCode}
            authType={authType}
            setOtpCode={setOtpCode}
            onBlur={validateOtp}
            changeCode={changeOtpCode}
            changeStep={changeStep}
            sendOtpCodeSubmit={sendOtpCodeSubmit}
            setError={setError}
          />
        );
      case ENABLE_AUTHENTICATION_STEPS.SendEmailCode:
        return (
          <SendEmailCode
            isLoading={isLoading}
            error={error}
            otpCode={otpCode}
            authType={authType}
            changeOtpCode={changeOtpCode}
            onBlur={validateOtp}
            changeStep={changeStep}
            sendOtpCodeSubmit={sendOtpCodeSubmit}
            setError={setError}
          />
        );
      case ENABLE_AUTHENTICATION_STEPS.SuccessMessage:
        return <SuccessMessage closeScreen={() => handleClose()} />;
      default:
        return (
          <SelectAuthenticationType
            isLoading={isLoading}
            type={authType}
            changeType={changeAuthenticationType}
            changeStep={changeStep}
            getSecretKeySubmit={getSecretKeySubmit}
          />
        );
    }
  };

  return (
    <div css={css(twoFaPage)}>
      <div
        css={css(logoBlock, {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        })}
      >
        <Logo />

        <LanguageSelection />
      </div>

      <div css={css(twoFaPageContainer)}>
        <div css={css(titleArea)}>
          <MainIcon step={step} />
          <Title step={step} />
        </div>
        {renderMainContent()}
      </div>
    </div>
  );
};

export default TwoFactorRequirement;
